import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { SellerAgentComponent } from '../../../wholesale-cd-wizard/steps/seller-agent/seller-agent.component';
import { TitleInformationComponent } from '../../../wholesale-cd-wizard/steps/title-information/title-information.component';
import { EscrowInformationComponent } from '../../../wholesale-cd-wizard/steps/escrow-information/escrow-information.component';
import { SettlementAgentComponent } from '../../../wholesale-cd-wizard/steps/settlement-agent/settlement-agent.component';
import { CdContactInfo, TitleInfo } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

@Component({
  selector: 'contact-information',
  templateUrl: './contact-information.component.html',
  styleUrls: ['./contact-information.component.scss'],
  standalone: false
})
export class ContactInformationComponent extends ApplicationContextBoundComponent implements OnInit {

  @ViewChild('contactInfoForm') contactInfoForm: NgForm;

  @Input() sellerRealEstateAgent: CdContactInfo | undefined;
  @Input() titleInformation: TitleInfo | undefined;
  @Input() escrowInformation: CdContactInfo | undefined;
  @Input() settlementInformation: CdContactInfo | undefined;

  @ViewChild('sellerAgentSection') sellerAgentSection: SellerAgentComponent;
  @ViewChild('titleInfoSection') titleInfoSection: TitleInformationComponent;
  @ViewChild('escrowInfoSection') escrowInfoSection: EscrowInformationComponent;
  @ViewChild('settlementAgentSection') settlementAgentSection: SettlementAgentComponent;

  isLoading: boolean = false;

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  validateForm(): boolean {
    let isValid = true;

    if (this.sellerAgentSection) {
      isValid = this.sellerAgentSection.validateForm() && isValid;
    }

    if (this.titleInfoSection) {
      isValid = this.titleInfoSection.validateForm() && isValid;
    }

    if (this.escrowInfoSection) {
      isValid = this.escrowInfoSection.validateForm() && isValid;
    }

    if (this.settlementAgentSection) {
      isValid = this.settlementAgentSection.validateForm() && isValid;
    }

    return isValid;
  }

  getFormData(): any {
    return {
      sellerAgent: this.sellerAgentSection?.getFormData() || null,
      titleInformation: this.titleInfoSection?.getFormData() || null,
      escrowInformation: this.escrowInfoSection?.getFormData() || null,
      settlementAgent: this.settlementAgentSection?.getFormData() || null
    };
  }
}
